<template>
  <v-card class="ret-card ret-link-card ret-rounded-card" @click.native="$emit('click', item)" data-test="issue">
    <v-card-text class="ret-compact">
      <v-container fluid class="ret-compact">
        <v-layout row>
          <v-flex xs9>
            <p class="ret-compact" v-if="showAsset">
              <v-icon small class="ret-card-icon" color="primary">devices</v-icon>
              {{ item.asset.fullPath }}
            </p>
            <p class="ret-compact">
              <v-icon small class="ret-card-icon">build</v-icon>
              {{ item.xDisplayName }}
            </p>
          </v-flex>
          <v-flex xs3 class="ret-align-right">
            <div class="ret-compact">
              <p v-if="!dayDividers" class="ret-compact ret-opacity-54">{{ item.actionAt | dateOnly }}</p>
              <v-icon v-if="item.failure" color="warn">error_outline</v-icon>
              <v-icon v-if="item.isInProgress" color="grey lighten-1">hourglass_empty</v-icon>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<style scoped>
  div.card__actions.ret-compact {
    padding-left: 16px;
    padding-right: 16px;
  }

  div.container.ret-compact.fluid {
    padding: 0;
  }

  .theme--light.v-card.ret-rounded-card {
    margin: 3px;
    background-color: rgba(255, 255, 255, 0.0);
    box-shadow: none;
    border: 1px solid rgba(0, 0, 0, 0.14);
    border-radius: 8px;
  }

  .theme--light.v-card.ret-rounded-card:hover {
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12);
  }
</style>

<script>
import displayHelpers from '../../helpers/display-helpers.es6'

export default {
  name: 'issue-card',
  mixins: [displayHelpers],
  props: {
    item: Object,
    showAsset: Boolean,
    dayDividers: Boolean
  }
}
</script>
